import { all, call, put, takeLatest } from "redux-saga/effects";
import { StatusCodes } from "http-status-codes";
import { request } from "src/utils/api";
import {
  loginFailure,
  loginSuccess,
  logoutFailure,
  logoutSuccess,
  otpFailure,
  otpSuccess,
} from "../slices/authSlice";
import { LOGIN_DATA, LOGOUT, VERIFY_OTP } from "../actions/authAction";
import notification from "antd/es/notification";

function* loginFetchRequest(action: any): Generator<any, void, any> {
  try {
    const result = yield call(request, action.payload);
    if (result.status === StatusCodes.OK) {
      yield put(loginSuccess(result.data));
      yield call(() => localStorage.setItem("token", result.token));
      // yield call(setItem, 'token', result.token, 'local');
      // yield call(setItem, 'username', action.payload.body.userName, 'local');
    } else {
      yield put(loginFailure(result.message));
      notification.error({
        message: "Login Failed",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    }
  } catch (error: any) {
    yield put(loginFailure(error.message));
  }
}

function* otpSaga(action: any): Generator<any, void, any> {
  try {
    const result = yield call(request, action.payload);
    if (result.status === StatusCodes.OK) {
      yield put(otpSuccess(result.data));
      yield call(() => localStorage.setItem("token", result.token));
      yield call(() =>
        localStorage.setItem("userData", JSON.stringify(result))
      );
    } else {
      yield put(otpFailure(result.message));
      notification.error({
        message: "OTP Failed",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    }
  } catch (error: any) {
    yield put(otpFailure(error.message));
  }
}

function* LogoutSaga(action: any): any {
  try {
    const response = yield call(request, action.payload);
    if (response.status === 200) {
      yield put(logoutSuccess());
    } else {
      yield put(logoutFailure("Logout failed"));
    }
  } catch (error: any) {
    yield put(logoutFailure(error.message));
  }
}

export default function* authSaga() {
  yield all([
    takeLatest(LOGIN_DATA, loginFetchRequest),
    takeLatest(VERIFY_OTP, otpSaga),
    takeLatest(LOGOUT, LogoutSaga),
  ]);
}
